<div (click)="navigateToDetails()"
     class="session-resources-container w-full h-full">
  <div class="w-full h-[40%]">
    <app-image [url]="(data?.imgUrl || data.imageUrl) | cdnBaseUrl"
               class="resource-img"></app-image>
  </div>
  <div class="w-full h-[60%] flex flex-col justify-between">
    <div class="flex flex-col p-[1rem] space-y-[1rem]">
      <div>
        <div *ngFor="let category of data?.categories; let i=index;"
             class="category-btn mt-[0.5rem] mr-[0.5rem]"
             [style.background-color]="categoryHexColorCode[i%categoryHexColorCode.length]">
          {{category.value}}
        </div>
      </div>
      <span class="title">
            {{data?.title}}
          </span>
      <span class="description">
            {{data?.description}}
          </span>
    </div>
  </div>
</div>
